module.exports = __webpack_public_path__ + "img/load_text.d0f50669.jpg";